import React from 'react'
import { Modal, Button } from "react-bootstrap"
import { FaWhatsapp } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';

export default function PackageNotPermission({ isModalLess, handleCloseModalLess, title  }) {

    // on contact team service
    const onContactTeamService = () => {
        const phoneNumber = '02055963782';  // Change this to your contact number
        const message = 'ສະບາຍດີ ';  // Optional message to pre-fill
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

        window.open(url, '_blank');
    };

    return (
        <Modal centered show={isModalLess}>
            <Modal.Body style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20, flexDirection: 'column' }}>
                <h1>ແຈ້ງເຕືອນ!</h1>
                <p style={{ textAlign: 'center' }}>ຂໍອະໄພ ຮ້ານນີ້ແພັກເກັດອໍເດີ້ໝົດແລ້ວ ບໍ່ສາມາດນຳໃຊ້{title} ກະລຸນາຕໍ່ແພັກເກັດກ່ອນ ຫຼື ຕິດຕໍ່ຫາທິມງານດູແລລະບົບເພິ່ມເຕີມ</p>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center align-items-center gap-2">
                <Button variant="danger" size="lg" onClick={handleCloseModalLess}>
                    <MdClose style={{ fontSize: 26 }} /> ປີດອອກ
                </Button>
                <Button variant="success" size="lg" onClick={onContactTeamService}>
                    <FaWhatsapp style={{ fontSize: 26 }} /> 020 55 963 782
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
